/* talk·point — <tp-carousel>: horizontale Scroll-Sektion mit Prev/Next-Pfeilen.
   Markup: <tp-carousel><button data-dir="-1">…<div class="tp-track">…</div>
   IIFE + Guard: mehrere Sections binden dieses Script ein → ohne Kapselung würde
   `class TpCarousel` global doppelt deklariert (Uncaught SyntaxError).

   Pfeile ausserhalb des Elements: manche Sections setzen die Pfeile in den
   Kopfbereich (z. B. tp-home-guides, rechts neben die Einleitung). Solche
   Buttons erreicht `this.querySelectorAll` nie — sie blieben still wirkungslos.
   Deshalb die explizite Verknuepfung `<tp-carousel id="x">` +
   `<button data-dir="1" data-carousel="x">`. Nur explizit, nie geraten: bei
   mehreren Carousels je Section waere jede Heuristik mehrdeutig. */
(function () {
  if (customElements.get('tp-carousel')) return;

  /* Wheel-Latching (IT#16835, Teil 2): Chrome bindet eine Wheel-Geste an den ersten
     Scroller unter dem Cursor, der irgendeine Komponente der Geste aufnehmen kann —
     fuer die ganze Geste. Trackpad-Gesten haben fast immer ein paar Pixel deltaX,
     also haengt die Geste am horizontalen Track und die Seite steht (gemessen:
     0 px Seitenscroll bei deltaX=1/deltaY=100 ueber Bubbles, Produkt-Track, Slider).
     Vertikale Absicht (|dy| > |dx|) mit horizontaler Komponente reichen wir deshalb
     selbst an den Seiten-Scroller (Horizon-Squeeze: .page-wrapper) weiter.
     deltaX === 0 (Mausrad) bleibt nativ — dort chained Chrome korrekt und behaelt
     sein Smooth-Scrolling; rein horizontale Gesten bleiben ebenfalls nativ. */
  function pageScroller(from) {
    for (let el = from.parentElement; el; el = el.parentElement) {
      const o = getComputedStyle(el).overflowY;
      if ((o === 'auto' || o === 'scroll') && el.scrollHeight > el.clientHeight) return el;
    }
    return document.scrollingElement || document.documentElement;
  }
  function guardWheel(track) {
    if (!track || track.__tpWheelGuard) return;
    track.__tpWheelGuard = true;
    track.addEventListener('wheel', (e) => {
      if (e.ctrlKey || e.deltaX === 0) return;
      const ax = Math.abs(e.deltaX), ay = Math.abs(e.deltaY);
      if (ay <= ax) return;
      e.preventDefault();
      const f = e.deltaMode === 1 ? 16 : e.deltaMode === 2 ? window.innerHeight : 1;
      pageScroller(track).scrollBy({ top: e.deltaY * f, left: 0, behavior: 'instant' });
    }, { passive: false });
  }
  window.tpWheelGuard = guardWheel;
  // Horizons <slideshow-slides> (Hero-Slider) ist derselbe Fall — nur wo dieses
  // Script ohnehin geladen ist, kein eigener Loader.
  for (const s of document.querySelectorAll('slideshow-slides')) guardWheel(s);

  class TpCarousel extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('.tp-track');
      if (!track) return;
      guardWheel(track);
      const buttons = [...this.querySelectorAll('[data-dir]')];
      if (this.id) {
        const sel = `[data-dir][data-carousel="${CSS.escape(this.id)}"]`;
        for (const btn of document.querySelectorAll(sel)) {
          if (!buttons.includes(btn)) buttons.push(btn);
        }
      }
      // data-at-start/-end: für Auslauf + Weiter-Pfeil am Rand (tp-hero.css), die am
      // Ende der Reihe verschwinden sollen. Nur Attribute, kein Layout.
      const edges = () => {
        this.toggleAttribute('data-at-start', track.scrollLeft <= 4);
        this.toggleAttribute('data-at-end', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
      };
      track.addEventListener('scroll', edges, { passive: true });
      edges();
      for (const btn of buttons) {
        btn.addEventListener('click', () => {
          track.scrollBy({ left: Number(btn.dataset.dir) * Math.round(track.clientWidth * 0.85), behavior: 'smooth' });
        });
      }
      // Story-Bubbles (IT#16835): der rotierende Ring (::before, transform-Animation)
      // tickt in Chrome auf dem Main-Thread — 33 Bubbles = 33 Style-Updates pro Frame,
      // auch wenn der Track laengst aus dem Viewport ist. Jede Bubble einzeln beobachten:
      // so pausieren auch die im Track horizontal weggescrollten. Pausierte Animationen
      // erzeugen keine Style-Updates. Ohne JS/IO drehen alle wie bisher.
      if (this.classList.contains('tp-bubbles') && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          for (const en of entries) en.target.classList.toggle('tp-bub--idle', !en.isIntersecting);
        }, { rootMargin: '120px' });
        for (const bub of this.querySelectorAll('.tp-bub')) io.observe(bub);
      }
    }
  }
  customElements.define('tp-carousel', TpCarousel);
})();
